export default __webpack_public_path__ + "static/media/airstrapz-wht-4.a4f4b2b2.png";